export default __webpack_public_path__ + "static/media/3.23f52a60.jpeg";